import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'apollo-react/components/Modal';
import Button from 'apollo-react/components/Button';
import Typography from '../StyledTypography';
import StrategyRadioCard from './StrategyRadioCard';
import styles from './StrategySelectionModal.module.css';

const StrategySelectionModal = ({
  open,
  onClose,
  onSelectStrategy,
  title,
  message,
  strategies,
  footnote,
  id,
}) => {
  const { t } = useTranslation();
  const [selectedStrategy, setSelectedStrategy] = useState('');

  const handleClose = useCallback(() => {
    setSelectedStrategy('');
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    if (!selectedStrategy) return;
    onSelectStrategy(selectedStrategy);
    setSelectedStrategy('');
  }, [selectedStrategy, onSelectStrategy]);

  return (
    <Modal
      open={open}
      variant="warning"
      onClose={handleClose}
      title={title}
      hideButtons
      id={id}
    >
      <Typography className={styles.message}>{message}</Typography>

      <div className={styles.strategiesList}>
        {strategies.map(({ value, labelKey, descriptionKey }) => (
          <StrategyRadioCard
            key={value}
            value={value}
            selected={selectedStrategy === value}
            onSelect={setSelectedStrategy}
            labelKey={labelKey}
            descriptionKey={descriptionKey}
          />
        ))}
      </div>

      {footnote && (
        <Typography className={styles.footnote}>{footnote}</Typography>
      )}

      <div className={styles.actions}>
        <Button variant="secondary" onClick={handleClose}>
          {t('roleChange.cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={!selectedStrategy}
        >
          {t('roleChange.confirm')}
        </Button>
      </div>
    </Modal>
  );
};

export default StrategySelectionModal;
